import { Dropdown } from "react-bootstrap";
import styles from "./petcard.module.css";
import { Edit, MoreVertical, Trash2, X } from "react-feather";
import { useHistory } from "react-router-dom";
import { Dialog, Popover } from "@mui/material";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const PetCard = ({ item, setDeletePetModalOpen, setSelectedId, setEditData, setEditModalOpen, showBadge }) => {
  const { user, isAuthenticated } = useAuth0();
  const redirect = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [carImage, setCarImage] = useState("");
  const [openPop, setOpenPop] = useState(false);

  const handleOpen = () => {
    setOpenPop(true);
  }

  const handleClose = () => {
    setOpenPop(false);
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setCarImage("");
  }

  const open = Boolean(anchorEl);

  return (<div className={`${styles.ProspectCard}`} style={{ cursor: "pointer" }} onClick={(e) => {
    if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("pet:update") > -1) {
      setEditModalOpen(true);
      setEditData(item);
    } else {
      return false;
    }
  }}>
    <div className={`${styles.ProspectCardUnder}`}>
      <div className={`${styles.ProspectCardHeadSection}`}>
        <div className={`${styles.LeaseIMGSec} ${styles.Big}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          {item?.image_path ? (<span onMouseEnter={(e) => { setCarImage(item?.image_path); e.preventDefault(); e.stopPropagation(); handlePopoverOpen(e); }} onMouseLeave={handlePopoverClose} style={{ width: "100%", height: "100%" }}>
            <img src={item?.image_path} alt="" className={`${styles.CarUploadImage}`} />
          </span>) : (<img src="/static/img/pets.svg" alt="" className={`${styles.Icon}`} />)}
        </div>
        <div className={`${styles.LeaseIMGSec} ${styles.Small}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          {item?.image_path ? (<span onClick={(e) => { setCarImage(item?.image_path); e.preventDefault(); e.stopPropagation(); handleOpen(); }} style={{ width: "100%", height: "100%" }}>
            <img src={item?.image_path} alt="" className={`${styles.CarUploadImage}`} />
          </span>) : (<img src="/static/img/pets.svg" alt="" className={`${styles.Icon}`} />)}
        </div>

        <div className={`${styles.HeadConSec}`}>
          <div className={`${styles.prospectNameActionSec}`}>
            <p className={`${styles.ProsUserName} ${styles.CallLink}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/people/tenants/details/" + item.tenant_id); }}>{item?.tenant_name}</p>
            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("pet:update") > -1 || user["https://propertydek.com/permissions"].indexOf("pet:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
              <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                <MoreVertical />
              </Dropdown.Toggle>

              <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("pet:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(item); }}>
                  <Edit /> Edit
                </Dropdown.Item>}
                {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("pet:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeletePetModalOpen(true); setSelectedId(item?.id); }}>
                  <Trash2 /> Delete
                </Dropdown.Item>}
              </Dropdown.Menu>
            </Dropdown>}
          </div>
          <p className={`${styles.ProsUserName}`}>{item?.title}</p>
        </div>
      </div>
      <div className={`${styles.ProspectCardBodySec}`}>
        <ul>
          <li>
            <p className={`${styles.Title}`}>
              <img src="/static/img/color.svg" alt="" />
              Color :
            </p>
            <p className={`${styles.Content}`}>{item?.color}</p>
          </li>
          <li>
            <p className={`${styles.Title}`}>
              <img src="/static/img/weightScale.png" alt="" />
              Weight :
            </p>
            <p className={`${styles.Content}`}>{item?.weight}</p>
          </li>
          <li>
            <p className={`${styles.Title}`}>
              <img src="/static/img/pawprint.png" alt="" />
              Type :
            </p>
            <p className={`${styles.Content}`}>{item?.type}</p>
          </li>
          <li>
            <p className={`${styles.Title}`}>
              <img src="/static/img/home.svg" alt="" />
              Property :
            </p>
            <p className={`${styles.Content} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item?.property_name}</p>
          </li>
          <li>
            <p className={`${styles.Title}`}>
              <img src="/static/img/rooms.svg" alt="" />
              Unit :
            </p>
            <p className={`${styles.Content}`}>{item?.apt_no}</p>
          </li>
        </ul>
      </div>
      <div className={`${styles.TemplateCardFoot}`}>
        {showBadge && (<span className={styles.NewBadge}>New</span>)}
        {parseInt(item?.is_guest) === 1 && (<span className={`${styles.PublishBadge}`}>Guest</span>)}
      </div>
    </div>
    <Popover
      id="mouse-over-popover"
      sx={{ pointerEvents: "none" }}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <div className={`${styles.PopupImgSec}`}>
        <img src={carImage} alt="" />
      </div>
    </Popover>

    <Dialog
      open={openPop}
      onClose={(e) => { e.preventDefault(); e.stopPropagation(); handleClose(); }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className={`${styles.PopupImgSec}`}>
        <img src={carImage} alt="" />
        <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleClose(); }}><X /></button>
      </div>
    </Dialog>
  </div>);
};

export default PetCard;